/**
 * Sticky Search Fix
 * 
 * This script automatically closes the search bar when the user scrolls
 * if the search bar is currently open.
 */

document.addEventListener('DOMContentLoaded', function() {
  // Get the search container element
  const searchContainer = document.getElementById('search-container');
  
  // Add scroll event listener to the window
  window.addEventListener('scroll', function() {
    // Check if the search container exists and is currently active/open
    if (searchContainer && searchContainer.classList.contains('active')) {
      // Close the search container by removing the active class
      searchContainer.classList.remove('active');
    }
  });
});
